<template>
    <video class="tw-video" id="tw-video" :src="src" controls="controls" :poster="poster" :muted="muted" :autoplay="autoplay" :loop="loop" :width="width" :height="height">您的浏览器不支持 video 视屏播放</video>
</template>

<script>
export default {
    name: 'tw-video',
    props: {
        src: String,
        poster: String,
        muted: Boolean,
        autoplay: Boolean,
        loop: Boolean,
        height: {
            type: Number,
            default: 200
        },
        width: {
            type: Number,
            default: 300
        }
    }
}
</script>